export default __webpack_public_path__ + "static/media/download-icon.bab9837f.svg";